import GitHubIcon from '@mui/icons-material/GitHub';

import "../App.css"


function Sample() {
    return (
      <div className='page sample'>
        <h1 className="title sample-title">Your Next Dream App</h1>
        <p className='sample-tagline'>See what You can Build through 20+ Sample Apps</p>
        <div className="sample-rows">
          {SampleApps.map((sample, i) => (
            <div className="row sample-box" key={i}>
              <GitHubIcon className='github-icon'/>
              <div className='sample-box-text'>
                <a target="_blank" rel="noreferrer" href={sample.link} className="sample-link">{sample.title}</a>
                <p className="sample-des">{sample.des}</p>
              </div>
            </div>
          ))}          
        </div>
      </div>
    )
} 


const SampleApps = [
  {
    title: "nextjs-hackathon-template",
    des: "Next.js Hackathon Template made with Next.js 13",
    link: "https://github.com/descope/nextjs-hackathon-template"
  },
  {
    title: "nextjs-hackathon-template-pages",
    des: "Next.js Hackathon Template made with Next.js 12",
    link: "https://github.com/descope-sample-apps/nextjs-hackathon-template-pages"
  },
  {
    title: "b2c-retail-sample-app",
    des: "Welcome to Tee-Hee-Tees",
    link: "https://github.com/descope-sample-apps/b2c-retail-sample-app"
  },
  {
    title: "b2b-react-sample-app",
    des: "b2b-react-sample-app",
    link: "https://github.com/descope-sample-apps/b2b-react-sample-app"
  },
  {
    title: "passportjs_sample",
    des: "Todo App Sample App",
    link: "https://github.com/descope-sample-apps/passportjs_sample"
  },
  {
    title: "flask-sample-app",
    des: "Flask Sample App + Descope Auth",
    link: "https://github.com/descope-sample-apps/flask-sample-app"
  },
  {
    title: "flask-react-sample-app",
    des: "Flask + Descope Authentication (and a little bit of React)",
    link: "https://github.com/descope-sample-apps/flask-react-sample-app"
  },
  {
    title: "b2b-sample-app",
    des: "B2B Sample app",
    link: "https://github.com/descope-sample-apps/b2b-sample-app"
  },
  {
    title: "react-python-sample-app",
    des: "react-python-sample-app",
    link: "https://github.com/descope-sample-apps/react-python-sample-app"
  },
  {
    title: "zero-to-auth",
    des: "zero-to-auth App",
    link: "https://github.com/descope-sample-apps/zero-to-auth"
  },
  {
    title: "next-js-sample-app",
    des: "Next Descope Example",
    link: "https://github.com/descope-sample-apps/next-js-sample-app"
  },
  {
    title: "descope-escape-room",
    des: "Escape Room App",
    link: "https://github.com/descope-sample-apps/descope-escape-room"
  },
  {
    title: "descope-html-sample-app",
    des: "HTML Sample App",
    link: "https://github.com/descope-sample-apps/descope-html-sample-app"
  },
  {
    title: "swift-sample-app",
    des: "Swift Sample App",
    link: "https://github.com/descope-sample-apps/swift-sample-app"
  },
  {
    title: "django-descope",
    des: "Descope Django App",
    link: "https://github.com/descope/django-descope"
  }, 
  {
    title: "django-sample-app",
    des: "Build a Quillbot clone",
    link: "https://github.com/descope-sample-apps/django-sample-app"
  }, 
  {
    title: "waitlist-sample-app",
    des: "Waitlist app with Descope Flows and Airtable",
    link: "https://github.com/descope-sample-apps/waitlist-sample-app"
  },
  {
    title: "firebase-oidc-sample",
    des: "Implement Descope as an OIDC provider with Firebase",
    link: "https://github.com/descope-sample-apps/firebase-oidc-sample"
  },
  {
    title: "auth0-passkey-implementation",
    des: "Auth0 React SDK Sample App",
    link: "https://github.com/descope-sample-apps/auth0-passkey-implementation"
  },
  {
    title: "angular-webjs-sample-app",
    des: "Angular Sample App with Descope Web.js SDK",
    link: "https://github.com/descope-sample-apps/angular-webjs-sample-app"
  },
  {
    title: "aws-cognito-oidc-sample",
    des: "AWS Cognito with Descope in Hosted UI Sample App",
    link: "https://github.com/descope-sample-apps/aws-cognito-oidc-sample"
  }
] 


export default Sample
